import CHAT_EVENTS from 'lib/common/constants/chat/chatEvents';
import { AGENT_TASK_TRANSFER_FAILURE } from 'lib/common/constants/connectExceptions';

import toast from 'lib/common/utils/toast';

import getContactChatSession from '../../../utils/getContactChatSession';
import { TIME_TO_WAIT_FOR_TRANSFER_FAIL_MS } from '../constants/timeToWaitForTransferFailMS';
import addTransferConnection from './addTransferConnection';

// There's no way for us to unsubscribe the onMessage handler during transfer. This means if it fails, the handler stays listening and processing events.
// To avoid duplicate toasts and handling, we need a global map that's cleaned up when a transfer is successful
const transferEventSubscriptions = new Set<connect.Contact['contactId']>();

export default function transferChatTask(contact: connect.Contact, transferEndpoint: connect.Endpoint) {
  return new Promise(async (resolve, reject) => {
    // Ensures the transfer timeout doesn't run if we've handled the transfer
    let transferHandled = false;

    const chatSession = await getContactChatSession(contact);

    // Only set up a new listener if we've not previously transferred and have an active transfer listener
    if (!transferEventSubscriptions.has(contact.contactId)) {
      transferEventSubscriptions.add(contact.contactId);

      // Create a temporary handler to listen for transfer events. Would be challenging to surface or get events from
      // the task list
      chatSession?.onMessage((event) => {
        const { data } = event;

        // We only care about transfer events
        if (data.ContentType !== CHAT_EVENTS.TRANSFER_FAILED && data.ContentType !== CHAT_EVENTS.TRANSFER_SUCCEEDED) {
          return;
        }

        transferHandled = true;

        if (data.ContentType === CHAT_EVENTS.TRANSFER_SUCCEEDED) {
          // Disconnects the agent and all event listeners
          chatSession?.cleanUpOnParticipantDisconnect();

          transferEventSubscriptions.delete(contact.contactId);

          return resolve(undefined);
        }

        toast('error', AGENT_TASK_TRANSFER_FAILURE);

        return reject();
      });
    }

    // Transfer the chat
    await addTransferConnection(contact, transferEndpoint);

    setTimeout(() => {
      if (transferHandled) {
        return;
      }

      reject();
    }, TIME_TO_WAIT_FOR_TRANSFER_FAIL_MS);
  });
}
